import intlTelInput from 'intl-tel-input';
import 'intl-tel-input/build/css/intlTelInput.css';
import 'intl-tel-input/build/js/utils';

document.addEventListener('DOMContentLoaded', () => {
  const phoneInput = document.getElementById('phone-input');
  if (!phoneInput) return;

  // Initialize intl-tel-input  
  const iti = intlTelInput(phoneInput, {
    initialCountry: "auto",
    geoIpLookup: callback => {
      fetch("https://ipapi.co/json")
        .then(res => res.json())
        .then(data => callback(data.country_code))
        .catch(() => callback("sa"));
    },
    separateDialCode: true,
    preferredCountries: ['eg', 'sa', 'ae', 'us'],
    autoPlaceholder: "polite",
    formatOnDisplay: true,
    loadUtils: () => import("intl-tel-input/build/js/utils"),
  });

  // Add phone-input class if not present (for validation styling)
  phoneInput.classList.add('phone-input');
  
  // Get the form and submit button
  const form = phoneInput.closest('form');
  const submitButton = form?.querySelector('button[type="submit"], input[type="submit"]');
  
  const errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];
  
  // Validation function
  const validatePhone = () => {
    const value = phoneInput.value.trim();
    
    // Remove previous validation classes
    phoneInput.classList.remove('is-valid', 'is-invalid');
    
    // Only validate if there's input
    if (value) {
      if (iti.isValidNumber()) {
        phoneInput.classList.add('is-valid');
        // Enable submit button if phone is valid
        if (submitButton) {
          submitButton.disabled = false;
        }
      } else {
        phoneInput.classList.add('is-invalid');
        const errorCode = iti.getValidationError();
        const msg = errorMap[errorCode] || "Invalid number"
        console.log(msg)
        // Disable submit button if phone is invalid
        if (submitButton) {
          submitButton.disabled = true;
        }
      }
    } else {
      // If no value, enable submit button (phone might be optional)
      if (submitButton) {
        submitButton.disabled = false;
      }
    }
  };

  // Validate on input (as user types)
  phoneInput.addEventListener('input', validatePhone);
  
  // Validate when country changes
  phoneInput.addEventListener('countrychange', validatePhone);
  
  // Validate on blur (when input loses focus)
  phoneInput.addEventListener('blur', validatePhone);

  // Store iti instance on the input element for later access
  phoneInput.iti = iti;

  // Get country field (hidden input for user[country])
  const countryField = document.getElementById('country-iso-input');
  // Function to update country field
  const updateCountryField = () => {
    if (countryField) {
      const countryData = iti.getSelectedCountryData();
      if (countryData && countryData.iso2) {
        countryField.value = countryData.iso2.toUpperCase();
      }
    }
  };

  // Handle form submission
  if (form && !form.dataset.phoneHandlerAttached) {
    // Mark form to prevent duplicate handlers if multiple phone inputs exist
    form.dataset.phoneHandlerAttached = 'true';

    form.addEventListener('submit', (e) => {
      // Validate before submission
      validatePhone();

      // Check if phone number is valid
      if (phoneInput.value.trim() && !iti.isValidNumber()) {
        e.preventDefault();
        phoneInput.focus();
        return false;
      }

      // Set the full international number as the value
      if (iti.isValidNumber()) {
        phoneInput.value = iti.getNumber();
      }

      updateCountryField();
    });
  }
});
